module.exports = __webpack_public_path__ + "img/petstairs12.00e72c23.jpg";